import { ArrowLeft, Loader2, Save } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/shared/ui/button'

interface FormPageActionsProps {
  isEdit: boolean
  isSaving: boolean
  /** Create only: the Save button is enabled (e.g. there is something to save). */
  canSubmit: boolean
  onBack: () => void
  onSubmit: () => void
}

/** Back / Save buttons of a create-edit page header (Save exists on create only; edit saves per section). */
export function FormPageActions({
  isEdit,
  isSaving,
  canSubmit,
  onBack,
  onSubmit,
}: FormPageActionsProps) {
  const { t } = useTranslation()

  return (
    <div className="flex items-center gap-2">
      <Button variant="outline" onClick={onBack}>
        <ArrowLeft className="mr-1.5 h-4 w-4" />
        {t('common.back')}
      </Button>
      {!isEdit && (
        <Button disabled={isSaving || !canSubmit} onClick={onSubmit}>
          {isSaving ? (
            <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />
          ) : (
            <Save className="mr-1.5 h-4 w-4" />
          )}
          {t('common.save')}
        </Button>
      )}
    </div>
  )
}
